/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Subtitle_ImportInputs */



/**
* | output |
* | --- |
* | "Subtitle Import" |
*
* @param {Signup_Compare_Subtitle_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_subtitle_import = /** @type {((inputs?: Signup_Compare_Subtitle_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Subtitle_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Subtitle Import")
	if (locale === "de") return /** @type {LocalizedString} */ ("Subtitle Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Subtitle Import")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Subtitle Import")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtitle Import")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Subtitle Import")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Subtitle Import")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Subtitle Import")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subtitle Import")
	return /** @type {LocalizedString} */ ("Subtitle Import")
});